<template>
  <WelcomeMessage />

  <div class="dashboard">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <router-view v-if="!loading" :key="$route.fullPath" />
    <div v-else>
      <Skeleton width="100%" height="30%" />
      <Skeleton class="mt-3" width="100%" height="45%" />
    </div>
  </div>
</template>

<script>
import AppTopBar from "../layout/Investments/NavMenu.vue";
import WelcomeMessage from "../components/WelcomeMessage.vue";
import { useInvestmentStore } from "../store/investments/store";
import { RouterView } from "vue-router";
import Skeleton from "primevue/skeleton";

export default {
  components: {
    AppTopBar,
    WelcomeMessage,
    RouterView,
    Skeleton,
  },
  data() {
    return {
      isMenuClosed: false,
      isAboutRoute: false,
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    loading() {
      return useInvestmentStore().loading;
    },

    getContentStyle() {
      return {
        marginLeft: this.isMenuClosed ? "60px" : "250px",
      };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onMenuToggle(isMenuClosed) {
      this.isMenuClosed = isMenuClosed;
    },
    loadData() {
      const investmentStore = useInvestmentStore();
      investmentStore.getInitialObjects();
    },
  },
};
</script>

<style lang="scss">
.blur-effect {
  filter: blur(5px);
}
</style>

<style lang="scss" scoped>
.dashboard {
  position: relative;
}
.main {
  flex: 1;
  padding-top: 15px;
  padding-bottom: 20px;
  padding-right: 10px;
  padding-left: 20px;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
  @media (max-width: 767px) {
    margin-left: 60px !important;
  }
}
</style>
